import { render, staticRenderFns } from "./OverallReductionTargets.vue?vue&type=template&id=bc6eee02"
import script from "./OverallReductionTargets.vue?vue&type=script&lang=js"
export * from "./OverallReductionTargets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports